import { render, staticRenderFns } from "./codeCs.vue?vue&type=template&id=267d0b4b&"
import script from "./codeCs.vue?vue&type=script&lang=js&"
export * from "./codeCs.vue?vue&type=script&lang=js&"
import style0 from "./codeCs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports